import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';

import { MatDividerModule } from "@angular/material/divider";
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { TermsOfUseAcceptDialogComponent } from './components/terms-of-use-accept-dialog/terms-of-use-accept-dialog.component';
import { MainLayoutComponent } from './main-layout.component';

@NgModule({
  declarations: [
    MainLayoutComponent,
    TopbarComponent,
    SidenavComponent,
    TermsOfUseAcceptDialogComponent
  ],
  imports: [CommonModule, RouterModule, MatMenuModule, MatDialogModule, FormsModule, MatDividerModule],
})
export class MainLayoutModule { }
